import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatText'
})
export class FormatTextPipe implements PipeTransform {


  constructor() { }

  public transform(value: any) {
    try{
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    }catch(e){}
}

}
